// extracted by mini-css-extract-plugin
export default {"payment":"Ks","title_row":"Ls","border_bottom":"Ms","promo_wrapper":"Ns","payment_wrapper":"Os","label":"Ps","card_row":"Qs","cardcontain":"Rs","card_input":"Ss","card_error":"Ts","card_label":"Us","lock":"Vs","same_address":"Ws","place_order_button":"Xs","buttonwrap":"Ys","hide_form":"Zs","paypal_buttons":"at","review_button":"bt","alt_payment":"ct"};
    if(module.hot) {
      // 1715188229685
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  